/* eslint-disable import/prefer-default-export */
export const DISABLED_CALL_STATES = ["ended", "init"];
